const e=e=>`
    ${e} p { margin: 0; }
    ${e} li > p, li > h1, li > h2, li > h3, li > h4, li > h5, li > h6 { display: inline; }
    ${e} ol, ul { list-style-position: inside; }
    ${e} a { text-decoration: none }
`,t=`with-custom-fonts`;export{t as CUSTOM_FONTS_CLASS,e as buildAiComposerStyles};
//# sourceMappingURL=aiComposerStyles.js.map